export const Page = Object.freeze({
    HOME: 'home',
    CITY: 'city',
    LEGAL: 'legal',
    DESTINATION: 'destination',
    EVENT: 'event',
    AIRPORT: 'airport',
    CATEGORY: 'category',
    MID_FUNNEL: 'mid_funnel',
    NOT_FOUND: 'not_found',
    REDIRECT: 'redirect',
    CHECKOUT: 'checkout',
    FACILITY: 'facility',
});
